import type { TRuleWithTheme } from '@/styles/theme';

export const container: TRuleWithTheme = () => ({
    height: '15rem',
    minWidth: '15rem',
    overflow: 'auto',
    padding: '0.25rem',
});
